import { Timeline as MuiTimeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot, TimelineOppositeContent } from "@mui/lab";
import { Box, Typography, IconButton } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { motion } from "motion/react";
import WorkIcon from "@mui/icons-material/Work";
import SchoolIcon from "@mui/icons-material/School";
import BusinessIcon from "@mui/icons-material/Business";
import AnimatedCard from "../../components/AnimatedCard";
import { JourneyItem } from "./Timeline";

function getIcon(type?: string) {
    const t = (type || "").toLowerCase();
    if (t.includes("educ")) return <SchoolIcon />;
    if (t.includes("work")) return <WorkIcon />;
    return <BusinessIcon />;
}

export default function TimelineList({ items, isEditMode, isMobile, onEdit, onDelete }: any) {
    return (
        <MuiTimeline position={isMobile ? "right" : "alternate"}>
            {items.map((item: JourneyItem, idx: number) => {
                const isLast = idx === items.length - 1;
                const direction = isMobile ? 0 : idx % 2 === 0 ? -100 : 100;

                return (
                    <TimelineItem key={`${item.year}-${item.role}-${idx}`}>
                        {!isMobile && (
                            <TimelineOppositeContent sx={{ m: "auto 0" }}>
                                <Typography variant="body2" color="text.secondary">{item.year}</Typography>
                            </TimelineOppositeContent>
                        )}
                        <TimelineSeparator>
                            <TimelineDot color={(item.type || "").toLowerCase().includes("educ") ? "secondary" : "primary"}>
                                {getIcon(item.type)}
                            </TimelineDot>
                            {!isLast && <TimelineConnector />}
                        </TimelineSeparator>
                        <TimelineContent sx={{ py: 2, px: 2, position: "relative" }}>
                            {isMobile && <Typography variant="body2" color="text.secondary" mb={1}>{item.year}</Typography>}
                            <motion.div initial={{ opacity: 0, x: direction }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.5, delay: idx * 0.1 }}>
                                <AnimatedCard item={item} />
                            </motion.div>
                            {isEditMode && (
                                <Box sx={{ position: "absolute", top: 0, right: 0, display: "flex" }}>
                                    <IconButton size="small" onClick={() => onEdit(item)}><Edit fontSize="small" /></IconButton>
                                    <IconButton size="small" onClick={() => onDelete(item)}><Delete fontSize="small" color="error" /></IconButton>
                                </Box>
                            )}
                        </TimelineContent>
                    </TimelineItem>
                );
            })}
        </MuiTimeline>
    );
}
